import template from './tableGrid.html';
import controller from './tableGrid.controller';

let tableGridComponent = {
  restrict: 'E',
  require: '^^tableComponent',
  transclude: true,
  bindings: {
    columns: '=',
    data: '=',
    metaData: '=',
    sortBy: '=',
    options: '=',
    getNextSetOfRowsToFetch: '&',
    toggleSort: '&',
    toggleHeaderCheckbox: '&',
    rowOptions: '=',
    searchValue: '=',
    fetchResults: '&'
  },
  template,
  controller,
  controllerAs: 'vm',
  link: (scope) => {
    scope.vm = scope;
  }
};

export
default tableGridComponent;



// WEBPACK FOOTER //
// ./app/components/tableGrid/tableGrid.component.js